import { createResource } from 'acato-utils'

const API_URL = process.env.REACT_APP_API_URL

export const authResource = createResource({
  baseURL: `${API_URL}`
})
